import { render } from "./confirmCanceledSuscription.vue?vue&type=template&id=684fecd7"
import script from "./confirmCanceledSuscription.vue?vue&type=script&lang=js"
export * from "./confirmCanceledSuscription.vue?vue&type=script&lang=js"

import "./confirmCanceledSuscription.vue?vue&type=style&index=0&id=684fecd7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__